import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import BookDemoButton from "@/components/BookDemoButton";

const FeaturedTestimonialSection = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-6">
      <div className="w-full rounded-2xl border border-blue-400/20 bg-gradient-to-r from-blue-500/15 via-white/5 to-white/5 px-7 py-7 shadow-[0_18px_60px_rgba(0,0,0,0.16)] lg:px-10 lg:py-8">
        <div className="mb-5 flex flex-wrap items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white shadow-sm" aria-label="Capterra">
            <span className="relative block h-5 w-5 overflow-hidden rounded-[2px]" aria-hidden="true">
              <span className="absolute inset-0 bg-[#ff9d00] [clip-path:polygon(0_0,100%_0,50%_50%)]" />
              <span className="absolute inset-0 bg-[#ef4b38] [clip-path:polygon(0_0,50%_50%,0_100%)]" />
              <span className="absolute inset-0 bg-[#2563eb] [clip-path:polygon(0_100%,50%_50%,100%_100%)]" />
              <span className="absolute inset-0 bg-[#00a67e] [clip-path:polygon(100%_0,100%_100%,50%_50%)]" />
            </span>
          </div>
          <div className="flex items-center gap-1 text-amber-500" aria-label={t("featuredTestimonial.ratingLabel")}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Star key={index} className="h-4 w-4 fill-current" aria-hidden="true" />
            ))}
          </div>
          <span className="text-sm font-semibold text-white/60">5/5</span>
          <span className="feature-descriptor text-xs text-primary">
            {t("featuredTestimonial.label")}
          </span>
        </div>

        <blockquote>
          <p className="max-w-6xl text-lg font-medium leading-snug tracking-[-0.025em] text-white sm:text-xl lg:text-2xl">
            {t("featuredTestimonial.quoteStart")}{" "}
            <span className="text-primary">{t("featuredTestimonial.quoteHighlight")}</span>{" "}
            {t("featuredTestimonial.quoteEnd")}
          </p>
        </blockquote>

        <div className="mt-6 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-lg font-semibold text-white">— {t("featuredTestimonial.name")}</p>
            <p className="mt-1 text-sm text-white/55 sm:text-base">
              {t("featuredTestimonial.role")}
            </p>
          </div>

          <BookDemoButton
            label={t("nav.bookDemo")}
            source="homepage-featured-testimonial"
            buttonClassName="px-6 py-5"
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturedTestimonialSection;
